// ============================================================================
// MODAL — ContentListModal.jsx
// modals/ContentListModal.jsx
// ============================================================================

import React from 'react';
import './ContentListModal.css';

const TYPE_CFG = {
  lessons:   { icon: '📚', label: 'Lessons',          idField: 'lessonId'   },
  labs:      { icon: '🧪', label: 'Labs',              idField: 'labId'      },
  quizzes:   { icon: '📋', label: 'Quizzes',           idField: 'quizId'     },
  exams:     { icon: '📄', label: 'Exams',             idField: 'examId'     },
  capstones: { icon: '📘', label: 'Capstone Projects', idField: 'capstoneId' },
};

const ROLE_CFG = {
  admin:      { cls: 'clm--admin',      label: 'Admin'      },
  instructor: { cls: 'clm--instructor', label: 'Instructor' },
  student:    { cls: 'clm--student',    label: 'Student'    },
};

const itemMeta = (item, ct) => {
  if (ct === 'lessons')   return `${item.duration || 'N/A'} min`;
  if (ct === 'labs')      return `Due ${item.dueDate ? new Date(item.dueDate).toLocaleDateString() : 'N/A'} · ${item.maxGrade} pts`;
  if (ct === 'quizzes')   return `${item.questions?.length || 0} questions · ${item.maxGrade} pts`;
  if (ct === 'exams')     return `${item.questions?.length || 0} questions · ${item.duration} min`;
  if (ct === 'capstones') return `Due ${item.dueDate ? new Date(item.dueDate).toLocaleDateString() : 'N/A'} · ${item.maxGrade} pts`;
  return '';
};

const ContentListModal = ({
  visible, onClose,
  role = 'student',
  contentType = 'lessons',
  items = [],
  onView, onAdd, onDelete,
}) => {
  if (!visible) return null;
  const cfg     = TYPE_CFG[contentType] || TYPE_CFG.lessons;
  const roleCfg = ROLE_CFG[role]        || ROLE_CFG.student;
  const canAdd  = role === 'instructor' && !!onAdd;
  const canDel  = role === 'instructor' && !!onDelete;

  return (
    <div className="clm-overlay" onClick={onClose}>
      <div className={`clm-shell ${roleCfg.cls}`} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="clm-header">
          <div className="clm-icon">{cfg.icon}</div>
          <div className="clm-title-wrap">
            <div className="clm-title">{cfg.label}</div>
            <div className="clm-sub">{items.length} item{items.length !== 1 ? 's' : ''} · {roleCfg.label}</div>
          </div>
          <div className="clm-hdr-actions">
            {canAdd && <button className="clm-add-btn" onClick={onAdd}>+ Add New</button>}
            <button className="clm-close" onClick={onClose}>✕</button>
          </div>
        </div>

        {/* Body */}
        <div className="clm-body">
          {items.length === 0 ? (
            <div className="clm-empty">
              <div className="clm-empty-icon">{cfg.icon}</div>
              <div className="clm-empty-title">No {cfg.label.toLowerCase()} yet</div>
              {canAdd && <button className="clm-add-btn" onClick={onAdd}>+ Add First {cfg.label.slice(0, -1)}</button>}
            </div>
          ) : (
            <div className="clm-list">
              {items.map((item, idx) => {
                const id = item[cfg.idField];
                return (
                  <div key={id || idx} className="clm-item">
                    <span className="clm-item-id">{id}</span>
                    <div className="clm-item-info">
                      <div className="clm-item-title">{item.title}</div>
                      <div className="clm-item-meta">{itemMeta(item, contentType)}</div>
                    </div>
                    <div className="clm-item-actions">
                      <button className="clm-view-btn" onClick={() => onView?.(id)}>View →</button>
                      {canDel && <button className="clm-del-btn" onClick={() => onDelete?.(id)}>🗑</button>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentListModal;
